import { ReactNode, useEffect, useState } from "react";
import { GlobalLoadingContext } from "./GlobalLoadingContext";
import { useTenant } from "../Tenant";

interface Props {
  children: ReactNode;
}

export const GlobalLoadingProvider = ({ children }: Props) => {
  const [isGloballyLoading, setIsGloballyLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const { isTenantLoading } = useTenant();

  useEffect(() => {
    if (isTenantLoading) {
      setIsGloballyLoading(true);
    } else if (!isPageLoading) {
      setIsGloballyLoading(false);
    }
  }, [isTenantLoading, isPageLoading]);

  useEffect(() => {
    // Initial check
    const handlePageLoading = () => setIsPageLoading(false);
    if (document.readyState === "complete") {
      handlePageLoading();
    }

    // Add event listener for normal load
    window.addEventListener("load", handlePageLoading);

    // Safety timeout of 10 seconds
    const safetyTimeout = setTimeout(handlePageLoading, 10000);

    return () => {
      window.removeEventListener("load", handlePageLoading);
      clearTimeout(safetyTimeout);
    };
  }, []);

  return (
    <GlobalLoadingContext.Provider value={{ isGloballyLoading }}>
      {children}
    </GlobalLoadingContext.Provider>
  );
};
